import produce from 'immer';
import { create } from 'zustand';
import { SpotMarketConfig } from '@velocity-exchange/sdk';
import { MAIN_POOL_ID, UIMarket } from '@velocity-exchange/common';

/**
 * This store allows the deposit modal to persists the user inputs across opening and closing of the modal.
 */
export interface DepositInputStore {
	set: (x: (s: DepositInputStore) => void) => void;
	get: () => DepositInputStore;
	selectedSpotMarket: SpotMarketConfig;
	selectedPoolId: number;
	targetUserAccountKey: string;
	depositInputAmount: string;
	persistInputAmount: boolean;
}

const useDepositInputStore = create<DepositInputStore>(
	(set, get): DepositInputStore => ({
		set: (fn) => set(produce(fn)),
		get: () => get(),
		selectedSpotMarket: UIMarket.spotMarkets?.[0],
		selectedPoolId: MAIN_POOL_ID,
		targetUserAccountKey: '',
		depositInputAmount: '',
		persistInputAmount: false,
	})
);

export default useDepositInputStore;
